import { render, staticRenderFns } from "./TabDemographic.vue?vue&type=template&id=6e391a54&scoped=true&"
import script from "./TabDemographic.vue?vue&type=script&lang=js&"
export * from "./TabDemographic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e391a54",
  null
  
)

export default component.exports